module.exports = __webpack_public_path__ + "media/images/carrusel/delegaciones2-9481bf376e2cc7eccd9ad04536422967.jpg";